export default "__VITE_ASSET__BvdMps6v__"